/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomSummaryV3 } from './RoomSummaryV3';
import {
    RoomSummaryV3FromJSON,
    RoomSummaryV3FromJSONTyped,
    RoomSummaryV3ToJSON,
    RoomSummaryV3ToJSONTyped,
} from './RoomSummaryV3';
import type { RateValidationStatus } from './RateValidationStatus';
import {
    RateValidationStatusFromJSON,
    RateValidationStatusFromJSONTyped,
    RateValidationStatusToJSON,
    RateValidationStatusToJSONTyped,
} from './RateValidationStatus';
import type { RateValidationRawRateSummary } from './RateValidationRawRateSummary';
import {
    RateValidationRawRateSummaryFromJSON,
    RateValidationRawRateSummaryFromJSONTyped,
    RateValidationRawRateSummaryToJSON,
    RateValidationRawRateSummaryToJSONTyped,
} from './RateValidationRawRateSummary';

/**
 * A response to a v2 rate validation request
 * @export
 * @interface RateValidationResponseV2
 */
export interface RateValidationResponseV2 {
    /**
     * 
     * @type {number}
     * @memberof RateValidationResponseV2
     */
    gondolaRateId: number;
    /**
     * 
     * @type {number}
     * @memberof RateValidationResponseV2
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {string}
     * @memberof RateValidationResponseV2
     */
    checkin: string;
    /**
     * 
     * @type {string}
     * @memberof RateValidationResponseV2
     */
    checkout: string;
    /**
     * 
     * @type {string}
     * @memberof RateValidationResponseV2
     */
    occupancy: string;
    /**
     * 
     * @type {RateValidationRawRateSummary}
     * @memberof RateValidationResponseV2
     */
    originalRawRateSummary: RateValidationRawRateSummary;
    /**
     * 
     * @type {RateValidationRawRateSummary}
     * @memberof RateValidationResponseV2
     */
    updatedRawRateSummary?: RateValidationRawRateSummary;
    /**
     * 
     * @type {RoomSummaryV3}
     * @memberof RateValidationResponseV2
     */
    roomSummary?: RoomSummaryV3;
    /**
     * 
     * @type {RateValidationStatus}
     * @memberof RateValidationResponseV2
     */
    updateStatus: RateValidationStatus;
}



/**
 * Check if a given object implements the RateValidationResponseV2 interface.
 */
export function instanceOfRateValidationResponseV2(value: object): value is RateValidationResponseV2 {
    if (!('gondolaRateId' in value) || value['gondolaRateId'] === undefined) return false;
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    if (!('occupancy' in value) || value['occupancy'] === undefined) return false;
    if (!('originalRawRateSummary' in value) || value['originalRawRateSummary'] === undefined) return false;
    if (!('updateStatus' in value) || value['updateStatus'] === undefined) return false;
    return true;
}

export function RateValidationResponseV2FromJSON(json: any): RateValidationResponseV2 {
    return RateValidationResponseV2FromJSONTyped(json, false);
}

export function RateValidationResponseV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): RateValidationResponseV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'gondolaRateId': json['gondola_rate_id'],
        'vervotechPropertyId': json['vervotech_property_id'],
        'checkin': json['checkin'],
        'checkout': json['checkout'],
        'occupancy': json['occupancy'],
        'originalRawRateSummary': RateValidationRawRateSummaryFromJSON(json['original_raw_rate_summary']),
        'updatedRawRateSummary': json['updated_raw_rate_summary'] == null ? undefined : RateValidationRawRateSummaryFromJSON(json['updated_raw_rate_summary']),
        'roomSummary': json['room_summary'] == null ? undefined : RoomSummaryV3FromJSON(json['room_summary']),
        'updateStatus': RateValidationStatusFromJSON(json['update_status']),
    };
}

export function RateValidationResponseV2ToJSON(json: any): RateValidationResponseV2 {
    return RateValidationResponseV2ToJSONTyped(json, false);
}

export function RateValidationResponseV2ToJSONTyped(value?: RateValidationResponseV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gondola_rate_id': value['gondolaRateId'],
        'vervotech_property_id': value['vervotechPropertyId'],
        'checkin': value['checkin'],
        'checkout': value['checkout'],
        'occupancy': value['occupancy'],
        'original_raw_rate_summary': RateValidationRawRateSummaryToJSON(value['originalRawRateSummary']),
        'updated_raw_rate_summary': RateValidationRawRateSummaryToJSON(value['updatedRawRateSummary']),
        'room_summary': RoomSummaryV3ToJSON(value['roomSummary']),
        'update_status': RateValidationStatusToJSON(value['updateStatus']),
    };
}

